import React from 'react';
import './Event.css';

import { FaMapMarkerAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';  // Hook for translations

const Event = (props) => {
    // Destrukturyzacja props�w
    const { id, image, date, title, place } = props;
    const { t } = useTranslation();  // Initialize translation hook

    // Logika daty (zabezpieczona przed brakiem daty)
    let month = '';
    let year = '';
    let date2 = t(date); // Tłumaczenie daty
    if (date2) {
        const parts = date2.split(',');
        month = parts[0] ? parts[0].trim() : '';
        year = parts[1] ? parts[1].trim() : '';
    }

    return (
        <div className='event-item' key={id}>

            {/* Kontener zdj�cia */}
            <div className='image-container'>
                <img src={image} alt={t(title)} />
            </div>

            {/* Nak�adka z tre�ci� */}
            <div className='content'>

                {/* Box z dat� w prawym g�rnym rogu */}
                <div className="date-badge">
                    <span className="month">{month}</span>
                    <span className="year">{year}</span>
                </div>

                {/* Dolna sekcja: Tytu� i Lokalizacja */}
                <div className="text-content">
                    {/* TYTU� (Link do szczeg��w wydarzenia) */}
                    <Link to={`/events/${id}`} className='main-heading'>
                        {t(title)}
                    </Link>

                    {/* Lokalizacja */}
                    <div className='details'>
                        <h3>
                            <FaMapMarkerAlt className='icon' />
                            <span>{t(place)}</span>
                        </h3>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default Event;